module.exports = __webpack_public_path__ + "static/media/12 Personal My Room 001_1440.74a4455a.jpeg";